import { gql, useMutation } from '@apollo/client';

import { GET_HOLIDAY_LOCATION_BY_ID } from './get-holiday-location-by-id.hook';
import { GET_HOLIDAY_LOCATIONS_BY_COMPANY } from './get-holiday-locations-by-company.hook';

export const UPDATE_HOLIDAY_LOCATION = gql`
  mutation updateHolidayLocationById($payload: UpdateHolidayLocationInput!) {
    updateHolidayLocationById(payload: $payload) {
      _id
      name
    }
  }
`;

export const useUpdateHolidayLocation = () => {
  const [updateHolidayLocation] = useMutation(UPDATE_HOLIDAY_LOCATION, {
    refetchQueries: [GET_HOLIDAY_LOCATION_BY_ID, GET_HOLIDAY_LOCATIONS_BY_COMPANY],
  });

  return updateHolidayLocation;
};
